import React, { useEffect, useState, useContext } from 'react'
import AuctionTableView from '@/product/components/organisms/Auction/TableView'
import { Button } from '@mui/material'
import Layout from '../../product/components/templates/Layout'
import DynamicListing from './dynamicListing'
import DynamicContext from '@/product/context/dynamic/dynamicContext'
import ReportContext from '@/product/context/report/reportContext'
import AuctionListing from './AuctionListing'
import AuctionInvoice from './AuctionInvoice'
import { handleRedirectInternal } from '../../custom/common/components'
import { useHistory } from 'react-router-dom'

const AuctionLots = (props) => {
    const dynamicContext = useContext(DynamicContext)

    const { auction_tablefields } = dynamicContext

    const { getAllExportDownload } = useContext(ReportContext)

    const [searchInfo, setSearchInfo] = useState({})
    const [tableValue, setTableValue] = useState([])
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const history = useHistory()
    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'edit') {
            handleRedirectInternal(history, `auction/edit/${id}`)
        }
    }
    const onClickInvoiceEdit = (id, secondaryID, type) => {
        handleRedirectInternal(history, `invoice/view/${id}/${secondaryID}`)
    }

    const toggleFullScreenPopup = (popup, status, id) => {
        console.log(popup, status, id, 'toggle')
        if (popup && status == 'viewListing') {
            setManage({ popup, status, id })
        } else if (popup && status != '') {
            handleRedirectInternal(history, `auction/${status}/${id}`)
        } else {
            setManage({ popup, status, id })
        }
    }

    let action = props.match.params.action

    const custom = {
        action: {
            value: action == 'upcomming' ? 'open' : action,
            type: 'in',
            field: 'ac.market_status',
        },
    }

    useEffect(() => {
        if (auction_tablefields && auction_tablefields.length) {
            let dynamicValueAssign = {}
            let searchData = auction_tablefields
            searchData.map((data) => {
                if (data.field === 'title') {
                    data.click = true
                    data.onclick = onClickEdit
                    data.clickID = 'id'
                    data.secondaryClickID = 'user_id'
                    data.clickType = 'edit'
                    data.type = 'hyperlink'
                }
            })
            setTableValue(searchData)
            dynamicValueAssign.data = searchData
                .filter((item) => item.table_search === 1)
                .map((buscat) => {
                    return Object.assign(buscat, {
                        name: buscat.field,
                        type: 'text',
                    })
                })
            setSearchInfo(dynamicValueAssign)
        }
    }, [auction_tablefields, action])

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-between align-items-center mt-4">
                        <Button
                            id="dynamicAuction_add"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() =>
                                toggleFullScreenPopup(true, 'new', 0)
                            }
                        >
                            <span className="material-icons">add</span>Create a
                            new auction
                        </Button>

                        <Button
                            id="dynamicAuction_report"
                            variant="outlined"
                            className="btnOutlined"
                            onClick={() =>
                                getAllExportDownload({
                                    action: 'export',
                                    order: 'asc',
                                    orderby: '',
                                    search: 'all',
                                    report: `${action}_auction_management`,
                                })
                            }
                        >
                            <span className="material-icons-outlined">
                                file_download
                            </span>
                            Export All Data
                        </Button>
                    </div>

                    <AuctionTableView
                        searchInfo={searchInfo}
                        customFilter={custom}
                        tableValue={tableValue}
                        toggleFullScreenPopup={toggleFullScreenPopup}
                        columnStorageVariable={'table_auction'}
                        tableActionString={[
                            'removed',
                            'open',
                            'closenow',
                            'date_closed',
                        ]}
                        action={action}
                        showInvoice={true}
                        removeMoveToAuction={true}
                    />
                </div>
                <AuctionListing
                    data={manage}
                    function={toggleFullScreenPopup}
                />
                {/* <DynamicListing
                    data={manage}
                    function={toggleFullScreenPopup}
                /> */}
                {/* <AuctionInvoice
                    data={manage}
                    function={toggleFullScreenPopup}
                /> */}
            </Layout>
        </>
    )
}

export default AuctionLots
